import React, { useState, useEffect } from 'react'
import { Timeline } from '../../../../../../../components';
import { dateFormator } from '../../../../../../../utils';
import { convertFromUTC } from '../../../../../../../utils/dateUtils';
import { useDispatch, useSelector } from "react-redux";
import { recruiterReportsStart } from '../../../../../../../redux/slices/reports/reportsSlice';
import { formatWords2 } from '../../../../../../../utils/stringUtils';

const Activities = ({ data }) => {
  const [SubmissionData, setSubmissionData] = useState([])
  const [activities, setActivities] = useState([])
  const dispatch = useDispatch();
  const { recruiterReport } = useSelector((state) => state.reports) || {};
  const sourceLabelMap = {
    1: "internal DB",
    2: "Career Builder",
    3: "Monster",
    4: "Monster",
    5: "Monster",
    6: "Integrated Search",
  };

  const ApplicantSubStatus = {
    1: "shortlisted",
    2: "pipeline",
    3: "Submitted",
    4: "Review call by BDM",
    5: "BDM Interview",
    6: "Disqualified",
    7: "Hold",
    8: "Withdrawn",
    9: "Waiting for Writeup",
    10: "Submitted to Client",
    11: "Submitted To Vendor",
    12: "Shortlisted for Interview",
    13: "Interview Confirmation",
    14: "Interview Scheduled",
    15: "L1 Interview Scheduled",
    16: "L2 Interview Scheduled",
    17: "L3 Interview Scheduled",
    18: "L1 Interview Selected",
    19: "L2 Interview Selected",
    20: "L3 Interview Selected",
    21: "L1 Interview Rejected",
    22: "L2 Interview Rejected",
    23: "L3 Interview Rejected",
    24: "L1 Interview Re-Scheduled",
    25: "L2 Interview Re-Scheduled",
    26: "L3 Interview Re-Scheduled",
    27: "L1 Interview Feedback Pending",
    28: "L2 Interview Feedback Pending",
    29: "L3 Interview Feedback Pending",
    30: "Rejected By Client",
    31: "Selected but no response from the client",
    32: "Rejected after Client Selection",
    33: "Submitted to End Client",
    34: "Vendor Interview",
    35: "Vendor Interview Reject",
    36: "Client Interview",
    37: "Client Interview Select",
    38: "Client Interview Reject",
    39: "Client Interview Completed",
    40: "End Client Interview",
    41: "End Client Interview Completed",
    42: "Selected By Vendor",
    43: "Selected By Client",
    44: "Selected By End Client",
    45: "Rejected By Vendor",
    46: "Rejected by End Client",
    47: "Disqualified By Vendor",
    48: "Disqualified By Client",
    49: "Disqualified by End Client",
    50: "Hold By Vendor",
    51: "Hold By Client",
    52: "Hold by End Client",
    53: "Drop",
    54: "Position on Hold",
    55: "PW Interview Proposed By Buyer",
    56: "PW Interview Proposed By Supplier",
    57: "PW Interview Failed",
    58: "PW Interview Cancelled",
    59: "PW Interview Success",
    60: "Assignment Contract Sent",
    61: "Assignment Contract Verified",
    62: "Assignment Contract Rejected",
    63: "Confirmed",
    64: "Position Filled",
    65: "Backout",
    66: "Not Joined",
    67: "BGV Failed",
    68: "Got Pay Rate Confirmation",
    69: "Offer Withdrawn",
    70: "Negotiation",
    71: "Start",
    72: "Offer Sent",
    73: "Offer Accepted",
    74: "Offer Rejected",
    75: "Hold with Client",
    76: "Hold with Vendor",
    77: "Rejected Internally",
  };


  const buildJobTimeline = (submitDetails = []) => {
    const timeline = [];
    // Job creation
    if (data?.addedOn) {
      timeline.push({
        task: "Applicant Created",
        taskBy: `${formatWords2(data?.addedBy?.firstName)} ${formatWords2(data?.addedBy?.lastName)}` || "",
        designation: formatWords2(data?.addedBy?.role?.name ?? ""),
        taskDate: convertFromUTC(data?.addedOn),
        source: data?.source ? formatWords2(sourceLabelMap[data.source]) : "Unknown",
      });
    }

    // Submissions + Status
    submitDetails.forEach((submission) => {
      submission?.statusHistory?.forEach((sh) => {
        timeline.push({
          task: formatWords2(ApplicantSubStatus[sh?.status]),
          taskBy: `${formatWords2(sh?.addedBy?.firstName ?? "")} ${formatWords2(sh?.addedBy?.lastName ?? "")}`,
          designation: formatWords2(sh?.addedBy?.role?.name ?? ""),
          taskDate: convertFromUTC(sh?.addedOn),
          jobPostId: submission?.jobPostId?.jobInfo?.jobCode || "N/A",
          account: submission?.jobPostId?.companyId?.name ? formatWords2(submission?.jobPostId?.companyId?.name) : ""
        });
      });
    });

    timeline.sort((a, b) => new Date(b.taskDate) - new Date(a.taskDate));
    setActivities(timeline);
  };


  const handleSubmissions = async () => {

    try {
      //const res = await fetchRecruiterSummaryReport({
      const params = {
        coll: "Submission",
        fil: { candidateId: { type: "NONE", value: data?.uiid } },
        ret: "uiid statusHistory jobPostId candidateId",
        extret: "uiid firstName lastName role",
        ref: "JobPosting"
      };
      dispatch(recruiterReportsStart(params));
    } catch (err) {
      console.log("error", err)
    }
  };

  useEffect(() => {
    if (data?.uiid) {
      handleSubmissions();
    }
  }, [data?.uiid]);




  useEffect(() => {
    // if (recruiterReport?.data?.length) {
    //   buildJobTimeline(recruiterReport.data);
    // }
    buildJobTimeline(recruiterReport.data);
  }, [recruiterReport]);



  return (
    <div className="flex-1 py-5 rounded-xl shadow-xl inner-section px-6 overflow-hidden">
      <div className="flex justify-between p-3">
        <h6>Timeline</h6>
        <p className="text-sm font-semibold text-gray-400 ">
          From ({dateFormator(activities?.[activities.length - 1]?.taskDate, "full")}) To ({dateFormator(activities?.[0]?.taskDate, "full")})
        </p>
      </div>
      <Timeline
        data={activities}
      />
    </div>
  )
}

export default Activities